// src/components/utils/analytics.js

// By default we use the Google Ads account ID. The user can update this placeholder.
export const GOOGLE_ADS_ID = "AW-11537242137"; 
// Conversion labels can be configured below
export const GOOGLE_CONVERSION_LABEL_CLICK = "consultation_click"; 
export const GOOGLE_CONVERSION_LABEL_BOOKED = "consultation_booked"; 

/**
 * Dynamically loads the Google Ads tag (gtag.js) on the head
 */
export function initGoogleAds() {
  if (typeof window === "undefined" || !GOOGLE_ADS_ID) return;

  const path = window.location.pathname || "/";
  // Avoid injecting tracking scripts on admin or login routes
  if (/^\/(admin|login)(\/|$)/.test(path)) return;

  if (document.getElementById("gtag-js")) return;

  const script = document.createElement("script");
  script.id = "gtag-js";
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GOOGLE_ADS_ID);
  
  console.log(`[Analytics] Google Ads initialized with ID: ${GOOGLE_ADS_ID}`);
}

/**
 * Tracks standard events in Google Ads and local traffic log systems
 */
export function trackEvent(name, params = {}) {
  // 1. Log locally to our traffic tracking system if active
  if (window.lpfTrackEvent) {
    window.lpfTrackEvent(name, params);
  }

  // 2. Track event in Google Ads gtag
  if (window.gtag) {
    window.gtag("event", name, params);
  }
}

/**
 * Tracks a Google Ads Conversion specifically
 */
export function trackGoogleConversion(label) {
  if (window.gtag && GOOGLE_ADS_ID && label) {
    window.gtag("event", "conversion", {
      send_to: `${GOOGLE_ADS_ID}/${label}`,
    });
    console.log(`[Analytics] Google Ads Conversion tracked with label: ${label}`);
  }
}

/**
 * Listens to message events sent by Calendly widgets and tracks conversions
 */
export function setupCalendlyTracking() {
  if (typeof window === "undefined") return () => {};

  const handleMessage = (e) => {
    // Check that the event is from Calendly
    if (e.data && e.data.event && e.data.event.startsWith("calendly.")) {
      const eventName = e.data.event;
      console.log(`[Analytics] Calendly Event captured: ${eventName}`);

      if (eventName === "calendly.event_scheduled") {
        // Log local event
        trackEvent("calendly_booking_completed", {
          event_category: "Engagement",
          event_label: "Calendly consultation scheduled",
        });
        
        // Fire Google Ads conversion tracking for booked consultation
        trackGoogleConversion(GOOGLE_CONVERSION_LABEL_BOOKED);
      } else if (eventName === "calendly.date_and_time_selected") {
        trackEvent("calendly_datetime_selected", {
          event_category: "Engagement",
          event_label: "Calendly datetime selected",
        });
      }
    }
  };

  window.addEventListener("message", handleMessage);
  return () => {
    window.removeEventListener("message", handleMessage);
  };
}
